import { appApi } from 'dux/app/api';

type Country = {
  name: string;
  code: string;
  states: string[][];
};

const countriesApiSlice = appApi.injectEndpoints({
  endpoints: (build) => ({
    getCountries: build.query<Country[], void>({
      query: () => ({
        url: `v1/countries/`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0, // no caching for now
    }),
  }),
});

export const { useGetCountriesQuery } = countriesApiSlice;
